import React, { useState, useEffect } from "react";
import CustomButton from "../../common/CustomButton";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import {jwtDecode} from "jwt-decode";
import {  getVehicleClass, getDetailByRequestId, UploadDoc} from "../../api/serviceRequest";
import useStyles from "./AddVehicle_Styles";

export default function ButtonWidget(props) {
  const styles = useStyles();
  const RCNumber = props.RCNumber
  const previewImage =  props.previewImage
  const previewBackImage =  props.previewBackImage
  const vehicleNbrType =  props.vehicleNbrType
  const apiData =  props.apiData
  const mode = props.mode
  const selectedItem = props.selectedItem

  const enableAddVehicle = ()=>{
    let isEnable = true
    if(mode === 1 ){
      if(RCNumber?.length >=10){
        isEnable = true
      }else {isEnable = false}
    }
    return isEnable
  }

 
 
  const onClickVerify = async () => {
    let token = await AsyncStorageFunc.getData("TOKEN")
    let VehNumberData = {vehicleNo: vehicleNbrType == "RC Number" ? RCNumber : "", isChassis: vehicleNbrType == "RC Number" ? false : true, };
    var decoded = token ? jwtDecode(token) : "";
    let uploadPayload = new FormData();
    uploadPayload.append("data", JSON.stringify(VehNumberData));
    uploadPayload.append("filetype", "RC");
    uploadPayload.append("id", decoded.mappedOrgId + "");
    props.setLoading(true);
    UploadDoc(uploadPayload)
      .then((res) => {
        props.setVerifyApiData(res.data);
        props.setStepThreeEnable(true);
        if ((res.statusCode != 500 && res.statusCode > 0 && res.statusCode == 1013) || res.statusCode == -1040 || res.statusCode == 200) {
          if (!res?.data?.canApplyFasTag) {
            props.setLoading(false);
            switch (res?.data?.npci_TagStatus || res?.data?.cardStage) {
              case "Active":
                if (res.data.npci_BankId == "IDFC FIRST BANK") {props.setMode(3); } else { props.setMode(2);}
                break;
              case "Blacklist":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3); } else {  props.setMode(4); }
                break;
              case "Hotlisted":
                if (res.data.npci_BankId == "IDFC FIRST BANK") {props.setMode(3); } else { props.setMode(4);}
                break;
              case "Low Balance":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3); } else { props.setMode(4); }
                break;
              case "Blacklisted":
                if (res.data.npci_BankId == "IDFC FIRST BANK") {props.setMode(3); } else {  props.setMode(4); }
                break;
              case "Blacklisted, Low Balance":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3); } else { props.setMode(4); }
                break;
              case "Low Balance, Hotlisted":
                if (res.data.npci_BankId == "IDFC FIRST BANK") {props.setMode(3); } else { props.setMode(4); }
                break;
              case "Hotlisted, Low Balance":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3); } else { props.setMode(4);}
                break;
              case "Low Balance, Blacklisted":
                if (res.data.npci_BankId == "IDFC FIRST BANK") {props.setMode(3);} else { props.setMode(4);}
                break;
              case "Blacklisted,Low Balance":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3);} else { props.setMode(4); }
                break;
              case "Hotlisted, Blacklisted":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3);} else { props.setMode(4); }
                break;
              case "Blacklisted,Hotlisted":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3); } else { props.setMode(4);}
                break;
              case "Hotlisted, Blacklisted, Low Balance":
                if (res.data.npci_BankId == "IDFC FIRST BANK") { props.setMode(3);} else {  props.setMode(4); }
                break;
              default:
                props.setMode(0);
                break;
            }
          } else {
            if (res?.data?.requestId && res?.data?.requestId != "") {
              let params = {request_id: res?.data?.requestId + "", type: "RC", gender: null, emailId: null, id: decoded.mappedOrgId + "",};
              setTimeout(() => {
                getDetailByRequestId(params)
                  .then((response) => {
                    if ( response.statusCode == 500 || response.statusCode < 0 || response.statusCode == -1040 || response.statusCode == -1033) {
                      props.setLoading(false);
                      props.setStepThreeEnable(false);
                      props.setAlertModal({title: "Error", status: "error",message: response.message,navigateScreen: "", actionButton: "OK" });
                      props.setAlertModalVisible(true);
                    } else {
                      props.setApiData(response.response);
                      props.setLoading(false);
                      global.vehicle_class = response?.response?.commVeh;
                      global.applyNowData = response?.response;
                      if ( response?.response?.commVeh && response?.response?.commVeh != null && response?.response?.commVeh != "" ) { } else if (apiData.getManualSelection == true) {
                        props.setVcClassModal(true);
                      } }
                  })
                  .catch((err) => { props.setLoading(false); });
              }, 10000);
            }else if (res?.data?.canApplyFasTag) {
              props.setLoading(false);
              props.setMode(1);
              global.applyNowData = res.data;
              if (res?.data?.npci_vehicleClass) {
                global.vehicle_class = res?.data?.npci_vehicleClass;
              }

              global.applyNowUserId = res?.data?.userId;
              props.setApiData(res.data);
              if (res.data.getManualSelection) {
                props.setVcClassModal(true);
              }
            } }
          if ( res.statusCode < 0 || res.statusCode == 500 || res.statusCode == -1033 || res.statusCode == -1040 ) {
            props.setAlertModal({title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK" });
            props.setAlertModalVisible(true);
            props.setLoading(false);
            props.setStepThreeEnable(false);
          } }
        if (res.statusCode == 500) {
          props.setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK" });
          props.setAlertModalVisible(true);
          props.setLoading(false);
          props.setStepThreeEnable(false);
        }})
      .catch((err) => {
        props.setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK"});
        props.setAlertModalVisible(true);
      });};
 
  

  return (
    <>
    
        
                {RCNumber?.length>=1 ? (
                  <CustomButton
                    onPress={onClickVerify}
                    text={'Verify'}
                    disable={false}
                    style={styles.buttonAddVehicle}
                  />
                ) : (
                  <CustomButton
                    text={'Verify'}
                    disable={true}
                    style={ styles.buttonAddVehicleDisable}
                  />
                )}
                </>
             
  );}


